import { startCase } from 'lodash';
import { FilterOverviewFn, FilterOverviewType } from '../types';
import {
  PerformanceCategory,
  PerformanceFilterKey,
  PerformanceFilterValues,
  PerformanceViewByEnum,
} from './types';
import getLocationOverview from '../CommonFilters/Overviews/getLocationOverview';

export const initialValues: PerformanceFilterValues = {
  // Location filter
  locationId: [],
  locationsInactive: false,

  // Undefined
  viewBy: PerformanceViewByEnum.Year,

  // Sorting
  sortBy: 'year',
  sortOrder: 'desc',
};

export const defaultValues: Partial<PerformanceFilterValues> = {
  viewBy: PerformanceViewByEnum.Year,
  sortBy: 'year',
};

const getFilterCategory = (key: PerformanceFilterKey): PerformanceCategory => {
  switch (key) {
    case 'locationId':
      return 'location';
    case 'locationsInactive':
    default:
      return undefined;
  }
};

export const getFilterOverview: FilterOverviewFn<PerformanceFilterValues> = (
  key,
  state,
  t,
  _currentLocale,
) => {
  const value = state[key];
  const category = getFilterCategory(key);
  let result: FilterOverviewType = {
    key: key.toString(),
    helpText: t(
      `business_activity_packages.filter.${category}.${key}Field.label`,
      startCase(key.toString()),
    ),
    label: state[key]?.toString() || '',
    category,
  };

  switch (key) {
    case 'locationId':
      return getLocationOverview(t, result, value, 'performance');
    case 'sortBy':
    case 'sortOrder':
    case 'viewBy':
    case 'locationsInactive':
      return undefined;
    default:
      break;
  }

  return result;
};
